import { render, staticRenderFns } from "./DisputeAttachments.vue?vue&type=template&id=b24f869a"
import script from "./DisputeAttachments.vue?vue&type=script&lang=js"
export * from "./DisputeAttachments.vue?vue&type=script&lang=js"
import style0 from "./DisputeAttachments.vue?vue&type=style&index=0&id=b24f869a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports